<template lang="html">
  <div :class="titleClass ? 'titWrap':''">
    <h3 v-if="title && titleClass" :class="titleClass" :style="tStyle">{{ title }}</h3>
    <div v-else-if="title && !titleClass" class="inputLabel">{{ title }}</div>
    
    <div v-if="items && items.length > 0" class="radioWrap">
      <div v-for="(item, key, index) in items" :key="key" :class="(index != 0) ? 'mgt1': ''">
        <span class="rdChk">
          <input v-show="false"
            type="radio" 
            :id="`${title}-${getSelectValue(item,key)}`" 
            :value="getSelectValue(item,key)" 
            v-model="select"
            @change="$emit('update:val', select); activateSelect=false;"
            readonly
          >
          <label :for="`${title}-${getSelectValue(item,key)}`"><span v-show="false"></span></label>
        </span>
        <span class="alignL pl5px" :class="select === getSelectValue(item,key) ? 'active':''" 
          @click="$emit('update:val', getSelectValue(item,key)); activateSelect=false;">{{getSelectTitle(item)}}</span>
      </div>
    </div>
    <div v-else-if="lists" class="radioWrap" style="display: flex;" :style="cStyle">
      <div v-for="(item, key, index) in lists" :key="key" :class="(index != 0) ? 'mgl10p': ''">
        <span class="rdChk">
          <input type="radio" :id="key" :value="key" 
            v-model="select" 
            @change="$emit('update:val', select); activateSelect=false;"
            readonly
          >
          <label :for="key"><span style="font-size: 16px; line-height: 21px;">{{item}}</span></label>
        </span>
      </div>
    </div>
    <div v-else class="alignC inputLabel3">
      {{ description }}
    </div>
  </div>
  
</template>

<script>
  export default {
    props: {
      optionValId:{
        type:Boolean,
        default:false,
      },
      title: String,
      titleClass:String,
      tStyle:{
        type: String,
        default: '',
      },
      disable: Boolean,
      description: String,
      selected: {
        type: [String, Number]
      },
      items: {
        type: [Array, Object]
      },
      lists: {
        type: Object
      },
      cStyle: {
        type: String,
        default: '',
      },
      val: null,
    },

    watch: {
      selected(val){
        this.select = val
      },
    },
    computed: {
      selectValue() {
        let value = this.title;
        let item = undefined;

        if(this.items){
          if(this.optionValId)
            item = this.items.find((i)=> i.id == this.select);
          else
            item = this.items[this.select];
        }

        if(item !== undefined)
          value = this.getSelectTitle(item);
        return value;
      }
    },

    data() {
      return {
        select: this.selected,
        activateSelect: false,
      };
    },

    methods: {
      getSelectValue(item, key) {
        return (this.optionValId) ? item.id: key},

      getSelectTitle(item) {
        // 차량 select 일경우 group_title 보여야한다
        return (typeof item.group != 'undefined' && typeof item.ids != 'undefined' && item.ids.length > 1)
            ? item.group
            : item.title
      }
    },
  }
</script>

<style lang="css" scoped>
  .v-application ul {
    padding-left: 0px;
  }
  
</style>

